import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import Table3 from "../../../components/table/table-3";
import Table2 from "../../../components/table/table-2";
import { useEffect, useRef, useState } from "react";
import {
  getAllEmployee,
  getEmployeeById,
} from "../../../services/employee/employee-details-service";
import {
  createEmployeePermissionById,
  getEmployeePermissionById,
  updateEmployeePermissionById,
} from "../../../services/employee/employee-permission-service";
import { useGetAllEmployeePermission } from "../../../hook/employee/use-employee-permission";
import Loader from "../../../components/loader/loader";
import ViewEmployeePermissionById from "../../../components/viewsModals/view-employee-permission";
import { getRolePermissionById } from "../../../services/admin/role-service";
import { useGetAllRoles } from "../../../hook/admin/use-role";
import { useGetAllBranches } from "../../../hook/admin/use-branch";
import { useQuery } from "@tanstack/react-query";
import { Eye, Pen, Search, User2 } from "lucide-react";
import { showErrorToast, showSuccessToast } from "../../../utils/toast-utils";
import UpdateMode from "./components/updateMode";
import CreateMode from "./components/createMode";
import ViewEmployeeDataByID from "../../../components/viewsModals/ViewEmployeeDataById";
import AllPermission from "./components/all-permission";

const RolePermission = () => {
  const permissionColumns = [
    { key: "module", label: "Permission Module" },
    {
      key: "isGranted",
      label: "Grant Permission",
      render: (row, index, handleToggle) => (
        <input
          type="checkbox"
          checked={row.isGranted}
          onChange={() => handleToggle(index, "isGranted")}
        />
      ),
    },
  ];

  const [viewPermissionData, setViewPermissionData] = useState(null);

  const employeePermissionColumns = [
    { key: "name", label: "Employee Name" },
    { key: "role", label: "Role" },
    { key: "employeeRefrenceId", label: "Employee Id" },
    {
      key: "dashboard",
      label: "Dashboard",
      render: (row) => (
        <span
          className={`px-2 py-1 rounded-full text-xs font-medium ${
            row.dashboard
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
        >
          {row.dashboard ? "Allowed" : "Denied"}
        </span>
      ),
    },
    {
      key: "system",
      label: "System",
      render: (row) => (
        <span
          className={`px-2 py-1 rounded-full text-xs font-medium ${
            row.system
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
        >
          {row.system ? "Allowed" : "Denied"}
        </span>
      ),
    },
    {
      key: "isActive",
      label: "Active",
      render: (row) => (
        <span
          className={`px-2 py-1 rounded-full text-xs font-medium ${
            row.isActive === 1
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
        >
          {row.isActive === 1 ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      key: "created_at",
      label: "Created At",
      render: (row) => new Date(row.created_at).toLocaleString(),
    },
    {
      key: "action",
      label: "Action",

      render: (row) => (
        <div className="flex gap-2">
          <Button
            size="sm"
            variant="admin.secondary"
            onClick={() => handleViewPermission(row?.employeeId)}
          >
            View
          </Button>

          <Button
            size="sm"
            variant="admin.secondary"
            className="bg-yellow-600"
            onClick={() => handleEditPermission(row)}
          >
            Edit
          </Button>
        </div>
      ),
    },
  ];
  const selectRef = useRef();
  const [data, setData] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [appliedSearch, setAppliedSearch] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [formType, setFormType] = useState("create");
  const [employeeFetchedByRoleAndBranch, setEmployeeFetchedByRoleAndBranch] =
    useState(null);
  const [limit, setLimit] = useState(5);
  const { data: branches = [], isLoading: branchLoading } = useGetAllBranches();
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [employeeData, setEmployeeData] = useState(null);
  const [employeeDataLoading, setEmployeeDataLoading] = useState(false);
  const [employeeError, setEmployeeError] = useState(null);
  const [isAlreadyCreatedPermission, setIsAlreadyCreatedPermission] =
    useState(false);
  const [isEditClicked, setIsEditClicked] = useState(false);
  const [singleEmployeeData, setSingleEmployeeData] = useState(null);
  const [isViewLoading, setIsViewLoading] = useState(false);
  const [permissionIndex, setPermissionIndex] = useState(0);

  const {
    data: getAllEmployeePermission,
    isLoading: isgetAllEmployeePermissionLoading,
    refetch,
    error,
  } = useGetAllEmployeePermission(page, limit);
  const { data: roles = [], isLoading: rolesLoading } = useGetAllRoles();
  const [selectedRole, setSelectedRole] = useState(null);

  const fetchPermissions = async (id) => {
    try {
      if (!id) return;

      setIsLoading(true);

      const res = await getEmployeePermissionById({ id });
      const apiData = res?.data?.data;

      const formattedPermissions = [
        {
          module: "Dashboard",
          isGranted: Boolean(apiData?.dashboard),
        },
        {
          module: "System",
          isGranted: Boolean(apiData?.system),
        },
      ];

      if (res?.data?.data?.permissionId) {
        setIsAlreadyCreatedPermission(true);
        setFormType("update");
      } else {
        setIsAlreadyCreatedPermission(false);
        setFormType("create");
      }

      setData(formattedPermissions);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClick = async () => {
    console.log("CLICKED");
    setSelectedBranch("");
    setSelectedRole("");
    setSelectedEmployee("");
    try {
      setIsLoading(true);
      const res = await getAllEmployee({
        appliedSearch,
        hospital_branch_id: selectedBranch?.hospitalId,
        role_id: selectedRole?.id,
      });
      const rows = res?.data?.data?.rows || [];

      setEmployeeList(rows);

      if (rows[0]?.id) {
        fetchPermissions(rows[0].id);
        setSelectedEmployee(rows[0]);
      }

      if (rows.length === 0) {
        setSelectedEmployee("");
        showErrorToast("No Employee Found");
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreatePermission = async (selectedId) => {
    try {
      if (!selectedId) {
        return;
      }
      setIsLoading(true);

      const payload = {
        employee_id: selectedId,
        dashboard:
          data.find((p) => p.module === "Dashboard")?.isGranted || false,
        system: data.find((p) => p.module === "System")?.isGranted || false,
      };

      const res = await createEmployeePermissionById({ payload });
      await refetch();

      if (res?.data?.status === 200) {
        showSuccessToast(res?.data?.message || res?.data?.data?.message);
      } else {
        showErrorToast(res?.data?.message || res?.data?.data?.message);
      }

      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  const handleUpdatePermission = async (selectedId) => {
    try {
      if (!selectedId) {
        return;
      }
      setIsLoading(true);

      const payload = {
        employee_id: selectedId,
        dashboard:
          data.find((p) => p.module === "Dashboard")?.isGranted || false,
        system: data.find((p) => p.module === "System")?.isGranted || false,
      };

      const res = await updateEmployeePermissionById({ payload });
      await refetch();

      if (res?.data?.status === 200) {
        showSuccessToast(res?.data?.message || res?.data?.data?.message);
      } else {
        showErrorToast(res?.data?.message || res?.data?.data?.message);
      }

      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
      setIsEditClicked(false);
    }
  };

  const handleViewPermission = async (id) => {
    try {
      if (!id) return;

      setIsLoading(true);

      const res = await getEmployeePermissionById({ id });

      const apiData = res?.data?.data;

      setViewPermissionData(apiData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditPermission = async (row) => {
    console.log(row);
    setIsEditClicked(true);

    setFormType("update");
    setSelectedEmployee(row);
    fetchPermissions(row.employeeId);
  };

  const handleViewEmployee = async (id) => {
    try {
      if (!id) return;

      setIsViewLoading(true);

      const res = await getEmployeeById({
        id: `${isEditClicked ? selectedEmployee.employeeId : selectedEmployee.id}`,
      });

      const apiData = res?.data?.data;

      setSingleEmployeeData(apiData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsViewLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedBranch?.id && !selectedRole?.id) return;

    const fetchEmployees = async () => {
      try {
        setEmployeeDataLoading(true);
        setEmployeeError(null);
        setSelectedEmployee("");

        const response = await getAllEmployee({
          hospital_branch_id: selectedBranch?.id,
          role_id: selectedRole?.id,
        });

        if (response?.data?.status === 200) {
          showSuccessToast(
            response?.data?.message || response?.data?.data?.message,
          );
        } else {
          showErrorToast(
            response?.data?.message || response?.data?.data?.message,
          );
        }

        setEmployeeData(response);
      } catch (error) {
        console.log("employeeError", error);

        setEmployeeError(error);
      } finally {
        setEmployeeDataLoading(false);
      }
    };

    fetchEmployees();
  }, [selectedBranch?.id, selectedRole?.id]);

  useEffect(() => {
    setEmployeeList(employeeData?.data?.data?.rows);
  }, [employeeData]);

  useEffect(() => {
    console.log(selectedEmployee);
  }, [selectedEmployee]);

  return (
    <>
      <div>
        <div
          className="w-full md:-mt-3 mb-2 px-5 py-2 rounded-2xl 
                      bg-gradient-to-r from-cyan-700 via-blue-600 to-cyan-700
              text-white shadow-lg"
        >
          {/* Header Title */}
          <div className="flex items-center gap-3 text-2xl font-semibold tracking-wide mb-4">
            <User2 className="w-6 h-6" />
            Manage Permission
          </div>

          {/* Tabs */}
          <div className="flex flex-wrap gap-3">
            {["individual Role Permission", "All Role Permission"].map(
              (item, index) => {
                const active = permissionIndex === index;

                return (
                  <button
                    key={item.id}
                    onClick={() => setPermissionIndex(index)}
                    className={`px-5 py-2.5 rounded-xl text-sm font-medium transition-all duration-200
                  ${
                    active
                      ? "bg-white text-indigo-600 shadow-md"
                      : "bg-white/20 text-white hover:bg-white/30"
                  }`}
                  >
                    {item}
                  </button>
                );
              },
            )}
          </div>
        </div>
      </div>

      {permissionIndex === 0 ? (
        <div className="sm:p-2">
          {(isgetAllEmployeePermissionLoading ||
            isLoading ||
            employeeDataLoading ||
            isViewLoading) && <Loader />}

          <div className=" border-b border-gray-200 pb-4">
            <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
              Individual Permission
            </h2>
            <p className="text-sm text-gray-500 mt-1">
              Manage and control employee access permissions
            </p>
          </div>
          <div className="grid grid-cols-1 gap-6">
            <Card className="border-none shadow-md bg-white ">
              <div className="flex justify-center gap-2 mt-4  w-full">
                <div className="w-full max-w-2xl px-4">
                  <div className="flex items-center gap-3">
                    <div className="relative flex-1">
                      <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />

                      <input
                        type="text"
                        placeholder="Search employee by ID..."
                        value={appliedSearch}
                        onChange={(e) => setAppliedSearch(e.target.value)}
                        className="w-full pl-10 pr-4 py-2.5 
                   rounded-full 
                   border border-gray-300 
                   bg-white 
                   text-sm
                   shadow-sm
                   focus:outline-none 
                   focus:ring-2 
                   focus:ring-blue-500 
                   focus:border-blue-500 
                   transition-all duration-200"
                      />
                    </div>

                    <Button
                      variant="admin.secondary"
                      disabled={!appliedSearch.trim()}
                      onClick={handleClick}
                      className="px-6 py-2.5 rounded-full shadow-sm"
                    >
                      Search
                    </Button>
                  </div>
                </div>
              </div>
              <div className="w-full p-6 grid grid-cols-1 md:gap-4 lg:gap-8 md:grid-cols-[1fr_1fr_1.5fr]">
                <div className="flex flex-col gap-2 mt-2">
                  <div>
                    <label className="font-semibold text-gray-700">
                      Select Role
                    </label>
                  </div>
                  <div>
                    <select
                      value={selectedRole?.id}
                      onChange={(e) => {
                        const selected = roles.find(
                          (role) => role.id === e.target.value,
                        );
                        setSelectedRole(selected);
                      }}
                      className="
                  w-full
                  px-4 py-2.5
                  text-sm md:text-base
                  bg-white
                  border border-gray-300
                  rounded-xl
                  shadow-sm
                  focus:outline-none
                  focus:ring-2 focus:ring-blue-500
                  focus:border-blue-500
                  transition-all duration-200
                  hover:border-gray-400
                  disabled:bg-gray-100 disabled:cursor-not-allowed
                "
                    >
                      <option value="">Select Role</option>
                      {!rolesLoading &&
                        roles.map((role) => (
                          <option key={role?.id} value={role?.id}>
                            {role?.roleName}
                          </option>
                        ))}{" "}
                    </select>
                  </div>
                </div>

                <div className=" flex w-full flex-col gap-2 mt-2">
                  <div>
                    <label className="font-semibold text-nowrap text-gray-700">
                      Hospital Branch
                    </label>
                  </div>
                  <div className=" mb-4">
                    <select
                      //size={5}
                      className="
                  w-full
                  px-4 py-2.5
                  text-sm md:text-base
                  bg-white
                  border border-gray-300
                  rounded-xl
                  shadow-sm
                  focus:outline-none
                  focus:ring-2 focus:ring-blue-500
                  focus:border-blue-500
                  transition-all duration-200
                  hover:border-gray-400
                  disabled:bg-gray-100 disabled:cursor-not-allowed
                  "
                      value={selectedBranch?.id || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        const branchDetails = branches?.find(
                          (br) => br.id === value,
                        );

                        setSelectedBranch(branchDetails || null);
                      }}
                    >
                      <option value="">Select Branch</option>

                      {branchLoading && <option>Loading...</option>}

                      {!branchLoading &&
                        branches?.map((branch) => (
                          <option key={branch?.id} value={branch?.id}>
                            {branch?.hospitalName}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="flex w-full flex-col gap-2 mt-2">
                  <div>
                    <h1 className="font-semibold text-md text-gray-700">
                      Select Employee
                    </h1>
                  </div>

                  <select
                    ref={selectRef}
                    className="
                w-full
                px-4 py-2.5
                text-sm md:text-base
                bg-white
                border border-gray-300
                rounded-xl
                shadow-sm
                focus:outline-none
                focus:ring-2 focus:ring-blue-500
                focus:border-blue-500
                transition-all duration-200
                hover:border-gray-400
                disabled:bg-gray-100 disabled:cursor-not-allowed
              "
                    value={selectedEmployee?.id || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      setIsEditClicked(false);

                      const fullEmployee = employeeList.find(
                        (emp) => emp.id === value,
                      );
                      setSelectedEmployee(fullEmployee || null);

                      if (fullEmployee?.roleId) {
                        console.log("fullEmployee id", fullEmployee?.id);
                        fetchPermissions(fullEmployee?.id);
                      }
                    }}
                    disabled={isLoading || employeeList?.length === 0}
                  >
                    <option value="">
                      {isLoading
                        ? "Loading..."
                        : employeeList?.length === 0
                          ? "No employee found"
                          : "Select Employee"}
                    </option>

                    {employeeList?.map((emp) => (
                      <option key={emp.id} value={emp.id}>
                        Name: {emp?.name} || Designation: {emp?.role} || Emp_id:
                        ({emp?.employeeId})
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </Card>

            {selectedEmployee?.name && (
              <Card className="rounded-xl border-none bg-white p-3">
                {isAlreadyCreatedPermission ? <UpdateMode /> : <CreateMode />}
                <CardHeader>
                  <CardTitle className="text-md md:text-xl flex items-center justify-between text-gray-600">
                    <div className="flex items-center gap-4">
                      Module Permissions for{" "}
                      <span className="text-2xl text-blue-500 text-extrabold">
                        {" "}
                        {selectedEmployee?.name?.charAt(0)?.toUpperCase() +
                          selectedEmployee?.name?.slice(1)}
                      </span>
                    </div>
                    <button
                      type="button"
                      onClick={handleViewEmployee}
                      className="
                  inline-flex items-center gap-2
                  px-4 py-2
                  rounded-xl
                  bg-blue-600
                  text-white
                  font-medium
                  text-sm
                  shadow-md
                  transition-all duration-200
                  hover:bg-blue-700
                  hover:shadow-lg
                  active:scale-95
                  focus:outline-none
                  focus:ring-2
                  focus:ring-blue-400
                  focus:ring-offset-2
                "
                    >
                      <Eye size={18} />
                      View Employee Details
                    </button>{" "}
                  </CardTitle>
                </CardHeader>

                <CardContent className="pl-4 text-[#081a3a] text-2xl md:text-4xl font-bold">
                  <Table3
                    columns={permissionColumns}
                    data={data}
                    setData={setData}
                    headerBg="bg-[#f1f5ff]"
                  />
                </CardContent>

                <CardContent>
                  <Button
                    variant="admin.secondary"
                    className={`${formType === "create" ? "bg-green-700" : "bg-yellow-600"}`}
                    onClick={
                      formType === "create"
                        ? () => handleCreatePermission(selectedEmployee?.id)
                        : () =>
                            handleUpdatePermission(
                              isEditClicked
                                ? selectedEmployee?.employeeId
                                : selectedEmployee?.id,
                            )
                    }
                  >
                    {formType === "create"
                      ? "create permission"
                      : "update permission"}
                  </Button>
                </CardContent>
              </Card>
            )}

            {getAllEmployeePermission?.data?.rows?.length > 0 && (
              <Card className="rounded-xl pb-12 border-none bg-white sm:p-3">
                <CardHeader>
                  <CardTitle className="text-md md:text-xl text-gray-600">
                    Module Permissions
                  </CardTitle>
                </CardHeader>

                <CardContent className=" text-[#081a3a] text-2xl md:text-4xl font-bold">
                  <Table2
                    columns={employeePermissionColumns}
                    data={getAllEmployeePermission?.data?.rows || []}
                    headerBg="bg-[#0a1f44]"
                    headerText="text-white"
                    rowsPerPage={2}
                  />
                </CardContent>

                <div className="flex justify-center gap-4 pt-4 border-t">
                  <Button
                    onClick={() => setPage((p) => Math.max(p - 1, 1))}
                    disabled={page === 1}
                    variant="admin.secondary"
                  >
                    Prev
                  </Button>

                  <span className="text-sm mt-2">
                    Page {page} of{" "}
                    {getAllEmployeePermission?.data?.totalPages || 1}
                  </span>

                  <Button
                    onClick={() =>
                      setPage((p) =>
                        Math.min(
                          p + 1,
                          getAllEmployeePermission?.data?.totalPages || 1,
                        ),
                      )
                    }
                    disabled={
                      page === getAllEmployeePermission?.data?.totalPages
                    }
                    variant="admin.secondary"
                  >
                    Next
                  </Button>
                </div>
              </Card>
            )}
          </div>
          {viewPermissionData && (
            <ViewEmployeePermissionById
              viewPermissionData={viewPermissionData}
              setViewPermissionData={setViewPermissionData}
            />
          )}

          {singleEmployeeData && (
            <ViewEmployeeDataByID
              viewEmployeeData={singleEmployeeData}
              setViewEmployeeData={setSingleEmployeeData}
            />
          )}
        </div>
      ) : (
        <AllPermission />
      )}
    </>
  );
};

export default RolePermission;
